import { categories } from '@/mocks/categories';
import { news } from '@/mocks/news';
import type { NewsArticle } from '@/types/news';

export function getCategoryById(id: string | undefined) {
  if (!id) return undefined;
  return categories.find((c) => c.id === id);
}

export function getNewsById(id: string | undefined) {
  if (!id) return undefined;
  return news.find((n) => n.id === id);
}

export function getNewsByCategory(categoryId: string): NewsArticle[] {
  return news.filter((n) => n.categoryId === categoryId);
}

export function getSortedByTime(list: NewsArticle[]): NewsArticle[] {
  return [...list].sort(
    (a, b) => new Date(b.publishedAt.replace(/-/g, '/')).getTime() - new Date(a.publishedAt.replace(/-/g, '/')).getTime(),
  );
}

export function getHotNews(limit = 5): NewsArticle[] {
  return [...news].sort((a, b) => b.views - a.views).slice(0, limit);
}

export function getRelatedNews(article: NewsArticle, limit = 3): NewsArticle[] {
  const sameCategory = news.filter((n) => n.id !== article.id && n.categoryId === article.categoryId);
  const byTag = news.filter(
    (n) => n.id !== article.id && n.categoryId !== article.categoryId && n.tags.some((t) => article.tags.includes(t)),
  );
  const merged = [...sameCategory, ...byTag];
  const seen = new Set<string>();
  return merged
    .filter((n) => {
      if (seen.has(n.id)) return false;
      seen.add(n.id);
      return true;
    })
    .slice(0, limit);
}

export function formatViews(views: number): string {
  if (views >= 10000) return `${(views / 10000).toFixed(1)}万`;
  return String(views);
}

export function parsePublishedAt(value: string): number {
  return new Date(value.replace(/-/g, '/')).getTime();
}

export function getReferenceNow(): number {
  return Math.max(...news.map((n) => parsePublishedAt(n.publishedAt))) + 60 * 60 * 1000;
}

export function searchNews(keyword: string): NewsArticle[] {
  const q = keyword.trim().toLowerCase();
  if (!q) return [];
  return news.filter(
    (n) =>
      n.title.toLowerCase().includes(q) ||
      n.summary.toLowerCase().includes(q) ||
      n.tags.some((t) => t.toLowerCase().includes(q)),
  );
}

export function getSuggestions(keyword: string, limit = 6): NewsArticle[] {
  return searchNews(keyword).slice(0, limit);
}